import { jsx as C } from "react/jsx-runtime";
const r = ({
  width: o,
  height: t,
  className: L
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: L,
    fill: "none",
    height: t,
    viewBox: "0 0 14 14",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M7.29894 3.18481L10.1 6.18419L4.01818 12.6974L1.52032 12.9928C1.44186 13.0027 1.36233 12.9935 1.28765 12.9658C1.21297 12.9382 1.14507 12.893 1.08901 12.8334C1.03295 12.7738 0.990161 12.7014 0.963842 12.6216C0.937522 12.5418 0.928345 12.4568 0.936996 12.3727L1.2171 9.69797L7.29894 3.18481ZM11.8332 2.7349L10.5181 1.32969C10.4205 1.22517 10.3047 1.14226 10.1772 1.08569C10.0497 1.02912 9.91309 1 9.77509 1C9.6371 1 9.50045 1.02912 9.37297 1.08569C9.24548 1.14226 9.12966 1.22517 9.03211 1.32969L7.79403 2.65467L10.5951 5.65405L11.8332 4.32907C11.9308 4.22462 12.0082 4.1006 12.0611 3.96409C12.1139 3.82758 12.1411 3.68126 12.1411 3.53349C12.1411 3.38572 12.1139 3.2394 12.0611 3.10289C12.0082 2.96638 11.9308 2.84236 11.8332 2.7379V2.7349Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  r as Content
};
